<!--
 * @description: 
 * @Author: Jay
 * @Date: 2021-09-17 12:00:29
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-11 16:09:32
-->
<template>
  <div>
    <!-- 顶部Tab 切换 -->
    <TopTab></TopTab>
    <!-- 页面路由 -->
    <router-view />
    <!-- 左下悬浮窗 -->
    <right-bottom></right-bottom>
    <!-- 底部信息 -->
    <root-bottom></root-bottom>
  </div>
</template>

<script>
// 顶部Tab 切换
import TopTab from "@/components/tab/top-tab.vue";
// 底部信息
import rootBottom from "@/components/bottom/root-bottom.vue";
// 左下悬浮窗
import RightBottom from "../components/bottom/right-bottom.vue";
export default {
  naem: "Root",
  components: {
    TopTab,
    rootBottom,
    RightBottom,
  },
};
</script>

<style lang="scss">
// body {
//   // 去掉横条
//   overflow-x: hidden;
//   // 去掉竖条
//   // overflow-y: hidden;
// }
//设置全局 页面宽度
// .root {
// width: 1024px;
// width: 100vw;
// }
</style>
